import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  tableBody: {
    color: '#2C454C'
  }
});

export const TableBody = (props: any) => {
  return (
    <View style={styles.tableBody}>
      {props.children}
    </View>
  )
};

export default TableBody;
